import { Table } from 'react-bootstrap';
import AccordionCard from '../AccordionCard';

const PaymentFileFormatOld = () => {
  return (
    <>
      <AccordionCard title="Format Table" parent="paymentFileAccordion">
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Position</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Position 1</td>
              <td>Always “P” for property Record</td>
            </tr>
            <tr>
              <td>Positions 2- 27</td>
              <td>Is being phased out and will not appear after 2009.</td>
            </tr>
            <tr>
              <td>Positions 28 - 36</td>
              <td>Property Serial Number</td>
            </tr>
            <tr>
              <td>Positions 37 - 43</td>
              <td>Tax Reference</td>
            </tr>
            <tr>
              <td>Positions 44 - 53</td>
              <td>Taxes Based on Assessed Value</td>
            </tr>
            <tr>
              <td>Positions 54 - 63</td>
              <td>Adjustments</td>
            </tr>
            <tr>
              <td>Positions 64 - 73</td>
              <td>Tax Balance Due (amount you are paying.)</td>
            </tr>
            <tr>
              <td>Positions 74 - 102</td>
              <td>
                Free text info that you would want to send to help in any research that may be
                needed.
              </td>
            </tr>
            <tr>
              <td className="fs-5 align-middle">Example</td>
              <td>
                PA0001 0100100010000018000010063100000000000000100631COMPANY1
                <br /> PA0001 0100100010000018000010063100000000000000100631COMPANY1
              </td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
    </>
  );
};

export default PaymentFileFormatOld;
